import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {AccountService} from "../../account/account.service";
import {CampaignService} from "../campaign.service";
import {CommonDataService} from "../../shared/services/common-data.service";
import {SettingsService} from "../../settings/settings.service";
import {FundraiserOrderMaterialsService} from "../../orders/materials/fundraiser-order-materials.service";
import {ScrollTopService} from "../../shared/services/scroll-top.service";

@Component({
    selector: 'app-campaign-complete',
    templateUrl: './campaign-complete.component.html',
    styleUrls: ['./campaign-complete.component.css']
})
export class CampaignCompleteComponent implements OnInit {

    msg = [];
    startDate;
    formGroup: FormGroup;
    currentUser;
    campaign;
    orders: any [] = [];
    netMemberships: number;
    orderedPackets = 0;
    noBanner = true;
    finalForm = true;
    nonProfit: boolean;
    billing: string;
    qtyMemberships: number;

    checkPrizeCards = false;
    checkDebitCards = false;
    checkTeacherFreeMembership = false;

    orderDTO: any = {
        'campaignId': null,
        'campaignName': null,
        'qtyForms': null,
        'qtyMemberships': null,
        'qtyTotal': null,
        'specialInstructions': null,
        'qtyPrizeCards': null,
        'qtyGiftCard20': null,
        'qtyGiftCard50': null,
        'qtyGiftCard100': null,
        'qtyTeacherFreeMembership': null,
        'totalDueOrder': 0,
        'shipToContact': null,
        'shipToAddress': null,
        'shipToCity': null,
        'shipToState': null,
        'shipToZipcode': null,
        'billingType': null,
        'checkPrizeCards': null,
        'checkDebitCards': null,
        'checkTeacherFreeMembership': null,
        'nonProfit': null,
        'orderType': null,
        'organizationType': null
    };

    constructor(private router: Router,
                private accountService: AccountService,
                private campaignService: CampaignService,
                private cdService: CommonDataService,
                private settingsService: SettingsService,
                private ordersService: FundraiserOrderMaterialsService,
                private route: ActivatedRoute,
                private scrollTopService: ScrollTopService) {

        this.formGroup = new FormGroup({
            'qtyForms': new FormControl(''),
            'qtyMemberships': new FormControl(''),
            'qtyTotal': new FormControl('', Validators.required),
            'requestBanner': new FormControl(''),
            'specialInstructions': new FormControl(''),
            'qtyPrizeCards': new FormControl(''),
            'qtyGiftCard20': new FormControl(''),
            'qtyGiftCard50': new FormControl(''),
            'qtyGiftCard100': new FormControl(''),
            'qtyTeacherFreeMembership': new FormControl(''),
            'shipToContact': new FormControl('', Validators.required),
            'totalDueOrder': new FormControl(''),
            'shipToAddress': new FormControl('', Validators.required),
            'shipToCity': new FormControl('', Validators.required),
            'shipToState': new FormControl('', Validators.required),
            'shipToZipcode': new FormControl('', Validators.required),
            'billingType': new FormControl('', Validators.required),
            'checkPrizeCards': new FormControl(''),
            'checkDebitCards': new FormControl(''),
            'checkTeacherFreeMembership': new FormControl(''),
            'checkOrganizationAddress': new FormControl('')
        });

        this.checkPrizeCards = false;
        this.checkDebitCards = false;
        this.checkTeacherFreeMembership = false;
    }

    ngOnInit() {
        this.scrollTopService.setScrollTop();

        this.settingsService.currentUser().subscribe(user => {
            this.currentUser = user;
            this.nonProfit = this.currentUser.organizationtype === 'NONPROFIT';
        }, error => {
            console.log('Error get current user');
        });

        this.route.params.subscribe(params => {
            this.loadCampaign(params['id']);
        });
    }

    calculateNetMemberships() {
        this.netMemberships = this.orderedPackets - this.formGroup.value.qtyTotal;
        // this.qtyMemberships = (this.netMemberships < 0) ? -this.netMemberships : null;
        this.orderDTO.totalDueOrder = (this.formGroup.value.qtyTotal || 0) * 27;
    }

    loadCampaign(id) {

        this.campaignService.getCampaign(id).subscribe(data => {

            this.campaign = data;
            this.startDate = new Date(this.campaign.startdate);
            this.campaignService.broadcastCampaignId(this.campaign.id);
            this.campaignService.broadcastCampaignStartDate(this.startDate);

            this.campaignService.getOrders(id).subscribe(data => {
                this.orders = data;
                if (this.orderedPackets === 0) {
                    for (let i = 0; i < this.orders.length; i++) {
                        if ( this.orders[i].orderStatusTypeString !== 'CANCELLED' ) { // filter out cancelled orders
                            this.orderedPackets += this.orders[i].qtyForms;
                        }
                    }
                }
            });
        }, error => {
            console.log('Not Found');
        });
    }


    validationFields() {

        // if (!this.formGroup.get('campaign').valid) {
        //     this.msg.push({severity: 'error', detail: 'Please enter a value for Select Campaign'});
        // }

        if (!this.formGroup.get('qtyForms').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter the total number of packets required'});
        }

        if (!this.formGroup.get('qtyTotal').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter the total number of memberships sold'});
        }

        if (!this.formGroup.get('qtyMemberships').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter the total number of memberships required'});
        }

        if (!this.formGroup.get('shipToContact').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter a value for Ship to Contact'});
        }

        if (!this.formGroup.get('shipToAddress').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter a value for Ship to Address'});
        }

        if (!this.formGroup.get('shipToCity').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter a value for City'});
        }

        if (!this.formGroup.get('shipToState').valid) {
            this.msg.push({severity: 'error', detail: 'Please select a value for State'});
        }

        if (!/[0-9/-]+$/.test(this.formGroup.value.shipToZipcode)) {
            this.msg.push({severity: 'error', detail: 'Zipcode may only contain integers 0-9 and - character'});
        } else {
            if (!this.formGroup.get('shipToZipcode').valid) {
                this.msg.push({severity: 'error', detail: 'Please enter a value for Zipcode'});

                if (this.formGroup.value.shipToZipcode.length < 5) {
                    this.msg.push({severity: 'error', detail: 'Zipcode must be at least 5 characters'});
                }
            }
        }

        if (!this.formGroup.get('billingType').valid) {
            this.msg.push({severity: 'error', detail: 'Please select a billing method.'});
        }

    }

    submit() {
        this.validationFields();
        this.submitOrder();
    }


    submitOrder() {
        if (this.formGroup.valid === false || this.msg.length > 0) {
            return;
        }

        this.orderDTO.campaignId = this.campaign.id;
        this.orderDTO.qtyMemberships = this.formGroup.value.qtyMemberships;
        this.orderDTO.qtyTotal = this.formGroup.value.qtyTotal;
        this.orderDTO.specialInstructions = this.formGroup.value.specialInstructions;
        this.orderDTO.shipToContact = this.formGroup.value.shipToContact;
        this.orderDTO.shipToAddress = this.formGroup.value.shipToAddress;
        this.orderDTO.shipToCity = this.formGroup.value.shipToCity;
        this.orderDTO.shipToState = this.formGroup.value.shipToState;
        this.orderDTO.shipToZipcode = this.formGroup.value.shipToZipcode;
        this.orderDTO.checkDebitCards = this.formGroup.value.checkDebitCards;
        this.orderDTO.checkPrizeCards = this.formGroup.value.checkPrizeCards;
        this.orderDTO.checkTeacherFreeMembership = this.formGroup.value.checkTeacherFreeMembership;
        this.orderDTO.qtyPrizeCards = this.formGroup.value.qtyPrizeCards;
        this.orderDTO.qtyGiftCard20 = this.formGroup.value.qtyGiftCard20;
        this.orderDTO.qtyGiftCard50 = this.formGroup.value.qtyGiftCard50;
        this.orderDTO.qtyGiftCard100 = this.formGroup.value.qtyGiftCard100;
        this.orderDTO.qtyTeacherFreeMembership = this.formGroup.value.qtyTeacherFreeMembership;
        this.orderDTO.organizationType = this.currentUser.organizationtype;
        this.orderDTO.orderType = 1;
        this.orderDTO.billingType = this.formGroup.value.billingType;

        const data = this.cdService.trimObjectData(this.orderDTO);

        this.ordersService.createOrder(data)
            .subscribe(
                data => {
                    this.cdService.setUnsavedChanges(false);
                    this.router.navigate(['campaign', 'thank-you', this.campaign.id]);
                },
                error => {
                    if (error.parameterErrors !== undefined) {
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            this.msg.push({severity: 'error', detail: error.parameterErrors[i].message});
                        }
                    } else if (error.message.length !== 0) {
                        this.msg.push({severity: 'error', detail: error.message});
                    }
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/campaign/campaign-complete/campaign-complete.component.ts